import { withInstall, withInstallDirective } from '@zoryn/utils'
import Popover from './src/popover.vue'
import PopoverDirective, { VPopover } from './src/directive'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZPopoverDirective: SFCWithInstall<typeof PopoverDirective> =
  withInstallDirective(PopoverDirective, VPopover)

export const ZPopover: SFCWithInstall<typeof Popover> & {
  directive: typeof ZPopoverDirective
} = withInstall(Popover, {
  directive: ZPopoverDirective,
})
export default ZPopover

export * from './src/popover'
